import {useParams, useNavigate, Link, NavLink} from "react-router-dom";
import React, {useContext, useEffect, useState} from "react";
import {doc, onSnapshot} from "firebase/firestore";
import {SupervisionPage} from "./supervision-page/supervision-page";
import {db} from "../../config/firebase";
import {setBaseURL} from "../../config/axios-chatbot";
import {AppBar, Button, Stack, Toolbar, Typography} from "@mui/material";
import {grey} from "@mui/material/colors";
import {UserAvatar} from "../../layouts/main-layout/header/Header";
import {SignInContext} from "../../context/SignInContext";
import {DialButton} from "./supervision-page/components/dial-button";

export const ProjectElectronLayout = () => {
  const {currentUser, onLogout} = useContext(SignInContext);
  const {projectId} = useParams();

  const [project, setProject] = useState(null);
  const navigate = useNavigate();


  useEffect(() => {
    if (projectId) {
      const unsubscribe = onSnapshot(doc(db, "projects", projectId), (doc) => {
        const newProject = doc.data() || {};
        if (newProject === undefined || newProject?.id === undefined || !newProject || !newProject?.id) {
          navigate("/projects")
        }
        newProject.id = projectId;
        setBaseURL(newProject?.configuration?.conversation_logger_api || process.env.REACT_APP_CHATBOT_BACKEND);
        setProject(newProject);
      });

      return () => unsubscribe();
    }
  }, [projectId])

  return (
    <>
      <AppBar position="static"
              sx={{
                bgcolor: "#fefefe",
                boxShadow: 0,
                zIndex: 100,
                borderBottom: 1,
                minHeight: "48px !important",
                borderColor: "divider"
              }}
      >
        <Toolbar
          sx={{
            bgcolor: "transparent",
            // display: "none",
            zIndex: 100,
            py: "0 !important",
            px: "8px !important",
            minHeight: "48px !important",
            justifyContent: "space-between"
          }}
        >
          <Stack direction={"row"} gap={1} alignItems={"center"}>
            <Button
              component={Link}
              to={"/projects"}
              variant={"text"}
              sx={{flexDirection: "row", color: "dark.main"}}
              startIcon={<img src={"/logo.svg"} alt={"logo"} width={30}/>}
            >
              <Typography fontWeight={700}>BlockFlow</Typography>
            </Button>
            <Button
              component={NavLink}
              to={"/projects"}
              sx={{
                borderRadius: 0,
                textTransform: "capitalize",
                color: "dark.main",
                "&.active": {
                  bgcolor: grey[200],
                  borderRadius: 1,
                  fontWeight: 500
                }
              }}
            >
              Projects
            </Button>
          </Stack>
          <Stack direction={"row"} gap={1} alignItems={"center"}>
            <DialButton project={project}/>
            <UserAvatar currentUser={currentUser} onLogout={onLogout}/>
          </Stack>
        </Toolbar>
      </AppBar>
      <SupervisionPage project={project}/>
    </>
  )
}